import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = "dva-admin-token";

const adminClient = axios.create({
  baseURL: API,
  timeout: 12000,
});

adminClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminListApps = async () => {
  const { data } = await adminClient.get("/admin/apps");
  return data;
};

export const adminCreateApp = async (payload) => {
  const { data } = await adminClient.post("/admin/apps", payload);
  return data;
};

export const adminUpdateApp = async (slug, payload) => {
  const { data } = await adminClient.put(`/admin/apps/${slug}`, payload);
  return data;
};

export const adminDeleteApp = async (slug) => {
  const { data } = await adminClient.delete(`/admin/apps/${slug}`);
  return data;
};

export const adminListMessages = async () => {
  const { data } = await adminClient.get("/admin/messages");
  return data;
};

export const adminDeleteMessage = async (id) => {
  const { data } = await adminClient.delete(`/admin/messages/${id}`);
  return data;
};

export default adminClient;
